import { render } from "./UritusedView.vue?vue&type=template&id=1f5f271c"
import script from "./UritusedView.vue?vue&type=script&lang=js"
export * from "./UritusedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__